export default {
    validate: (value, param) => {

        const regex = /[,.]/;
        const decimalSeparatorIndex = regex.test(value);

        if (decimalSeparatorIndex) {
            return parseFloat(value) <= parseFloat(param);
        } else {
            return parseInt(value) <= parseInt(param);
        }
    },
    message: (field, args) => {
        return `${field} deve ser menor ou igual à ${args[0]}.`
    },
}